module.exports = __webpack_public_path__ + "static/media/sun.75754e51.png";